"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useGetActivityByKey = _interopRequireDefault(require("../providers/ActivityKeyer/useGetActivityByKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _useGetActivityByKey.default;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VHZXRBY3Rpdml0eUJ5S2V5Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlR2V0QWN0aXZpdHlCeUtleS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlR2V0QWN0aXZpdHlCeUtleSBmcm9tICcuLi9wcm92aWRlcnMvQWN0aXZpdHlLZXllci91c2VHZXRBY3Rpdml0eUJ5S2V5JztcblxuZXhwb3J0IGRlZmF1bHQgdXNlR2V0QWN0aXZpdHlCeUtleTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O2VBRWVBLDRCIn0=